import { render, staticRenderFns } from "./OrderPerformanceToSaleDashboard.vue?vue&type=template&id=62d4c96b&scoped=true"
import script from "./OrderPerformanceToSaleDashboard.vue?vue&type=script&lang=js"
export * from "./OrderPerformanceToSaleDashboard.vue?vue&type=script&lang=js"
import style0 from "./OrderPerformanceToSaleDashboard.vue?vue&type=style&index=0&id=62d4c96b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d4c96b",
  null
  
)

export default component.exports